import { ICreatorBioLink } from './types'

export const linkToIdentifier = (link: ICreatorBioLink) => `${link.method}_${link.href}`
